
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Ellipse 43","fill":"none","stroke":"#000","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"15","cy":"15","r":"15","stroke":"none"}}),_c('circle',{attrs:{"cx":"15","cy":"15","r":"14"}})]),_c('g',{attrs:{"data-name":"Group 4273"}},[_c('path',{attrs:{"data-name":"Path 1585","d":"M16.142 9l-1.53 1.53 3.273 3.273H9v2.164h8.831l-3.219 3.219 1.53 1.53L22 14.858z","fill-rule":"evenodd"}})])])
          )
        }
      }
    